import { MARQUEE } from "./data";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#0B1120]/10 bg-[#0B1120] py-6">
      <div className="flex w-max animate-marquee">
        {items.map((t, i) => (
          <span key={i} className="flex items-center gap-10 pr-10 font-display italic text-3xl sm:text-5xl text-[#E8F6FD] whitespace-nowrap">
            {t}
            <svg viewBox="0 0 24 24" className="w-6 h-6 sm:w-8 sm:h-8" fill="#A8DCF2"><path d="M12 2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17l-6.1 3.4 1.5-6.8L2.2 9l6.9-.7z" /></svg>
          </span>
        ))}
      </div>
    </div>
  );
};
